import { SongWithVotes } from "./song";
import { ReturnOrError } from "../services/common";

export type GetPlaylist = () => Promise<ReturnOrError<Playlist>>;

export type Playlist = {
  songs: {
    page: SongWithVotes[];
  };
  timeDividerIndex?: number;
};

// Shown on the time divider on the kiosk and the performer view.
export const timeDividerText =
  "Songs below may not be played due to remaining show time";
